import { render, staticRenderFns } from "./period-sales.vue?vue&type=template&id=f15b7dc2&scoped=true&"
import script from "./period-sales.vue?vue&type=script&lang=js&"
export * from "./period-sales.vue?vue&type=script&lang=js&"
import style0 from "./period-sales.vue?vue&type=style&index=0&id=f15b7dc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15b7dc2",
  null
  
)

export default component.exports